import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	isActive: boolean | null;
	group: string | null;
	severity: string | null;
}

const initialState: IInitialState = {
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	isActive: null,
	group: null,
	severity: null,
	...defaultMeta,
};

const alarmManagement = createSlice({
	name: 'alarmManagement',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setStatus: (state, action: PayloadAction<{ isActive: boolean | null }>) => {
			state.isActive = action.payload.isActive;
			state.page = initialState.page;
		},
		setGroup: (state, action: PayloadAction<{ group: string | null }>) => {
			state.group = action.payload.group;
			state.page = initialState.page;
		},
		setSeverity: (state, action: PayloadAction<{ severity: string | null }>) => {
			state.severity = action.payload.severity;
			state.page = initialState.page;
		},
		resetAlarmManagementTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	resetAlarmManagementTable,
	setStatus,
	setGroup,
	setSeverity,
} = alarmManagement.actions;

export default alarmManagement.reducer;
